// extracted by mini-css-extract-plugin
export default {"actions":"StepActions--actions--BzPrj","next":"StepActions--next--AingL","cancel":"StepActions--cancel--3-h0-","or":"StepActions--or--+EfOc"};